// All lazy imports for pages and games
import { lazy } from "react";

// Pages
export const NotFound = lazy(() => import("../pages/NotFound"));
export const Games = lazy(() => import("../pages/Games"));
export const ProgressPage = lazy(() => import("../pages/Progress"));
export const About = lazy(() => import("../pages/About"));
export const Privacy = lazy(() => import("../pages/Privacy"));
export const Terms = lazy(() => import("../pages/Terms"));
export const Contact = lazy(() => import("../pages/Contact"));

// Games
export const MemoryMatch = lazy(() => import("../games/MemoryMatch/MemoryMatch"));
export const SimonSays = lazy(() => import("../games/SimonSays/SimonSays"));
export const QuickMath = lazy(() => import("../games/QuickMath/QuickMath"));
export const SpotDifference = lazy(() => import("../games/SpotDifference/SpotDifference"));
export const WordSearch = lazy(() => import("../games/WordSearch/WordSearch"));
export const StroopTest = lazy(() => import("../games/StroopTest/StroopTest"));
export const TowerOfHanoi = lazy(() => import("../games/TowerOfHanoi/TowerOfHanoi"));
export const WhackAMole = lazy(() => import("../games/WhackAMole/WhackAMole"));
export const NumberSequences = lazy(() => import("../games/NumberSequences/NumberSequences"));
export const AnagramSolver = lazy(() => import("../games/AnagramSolver/AnagramSolver"));
export const MazeSolver = lazy(() => import("../games/MazeSolver/MazeSolver"));
export const ReactionTest = lazy(() => import("../games/ReactionTest/ReactionTest"));
export const PatternMemory = lazy(() => import("../games/PatternMemory/PatternMemory"));
export const NBack = lazy(() => import("../games/NBack/NBack"));
export const WordPairs = lazy(() => import("../games/WordPairs/WordPairs"));
export const MentalRotation = lazy(() => import("../games/MentalRotation/MentalRotation"));
export const CrosswordPuzzle = lazy(() => import("../games/CrosswordPuzzle/CrosswordPuzzle"));
export const SlidingPuzzle = lazy(() => import("../games/SlidingPuzzle/SlidingPuzzle"));
export const Sudoku = lazy(() => import("../games/Sudoku/Sudoku"));
export const WordChain = lazy(() => import("../games/WordChain/WordChain"));
export const TaskSwitching = lazy(() => import("../games/TaskSwitching/TaskSwitching"));
export const SequenceRecall = lazy(() => import("../games/SequenceRecall/SequenceRecall"));
export const DualNBack = lazy(() => import("../games/DualNBack/DualNBack"));
export const Nonograms = lazy(() => import("../games/Nonograms/Nonograms"));
